import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";

/** Last-order-date countdown for festive gifting. */
export const LAST_ORDER_DATE = "2026-11-07T18:00:00+05:30";
export const LAST_ORDER_LABEL = "7 November, 6 PM";

const diff = (target) => {
  const ms = new Date(target).getTime() - Date.now();
  if (ms <= 0) return null;
  return {
    days: Math.floor(ms / 86400000),
    hours: Math.floor((ms / 3600000) % 24),
    mins: Math.floor((ms / 60000) % 60),
    secs: Math.floor((ms / 1000) % 60),
  };
};

export default function FestiveCountdown({ compact = false, testId = "festive-countdown" }) {
  const [left, setLeft] = useState(() => diff(LAST_ORDER_DATE));

  useEffect(() => {
    const t = setInterval(() => setLeft(diff(LAST_ORDER_DATE)), 1000);
    return () => clearInterval(t);
  }, []);

  if (!left) {
    return (
      <div data-testid={`${testId}-closed`} className="small-caps text-[10px] text-neutral-400">
        <Clock size={11} className="inline mr-1 text-[#F5B041]" /> Diwali gifting orders have closed — ask us about next-day availability
      </div>
    );
  }

  const units = [
    [left.days, "days"],
    [left.hours, "hrs"],
    [left.mins, "min"],
    [left.secs, "sec"],
  ];

  if (compact) {
    return (
      <span data-testid={testId} className="small-caps text-[10px] text-[#F5B041]">
        <Clock size={11} className="inline mr-1" />
        {left.days}d {String(left.hours).padStart(2, "0")}h {String(left.mins).padStart(2, "0")}m left to order
      </span>
    );
  }

  return (
    <div data-testid={testId} className="border border-[#F5B041]/30 bg-[#F5B041]/5 px-5 py-4">
      <div className="small-caps text-[10px] text-neutral-400 flex items-center gap-2">
        <Clock size={12} className="text-[#F5B041]" /> Last order date · {LAST_ORDER_LABEL}
      </div>
      <div className="flex items-end gap-5 mt-3">
        {units.map(([v, l]) => (
          <div key={l}>
            <div className="font-serif-display text-3xl text-[#F5B041] tabular-nums leading-none">
              {String(v).padStart(2, "0")}
            </div>
            <div className="small-caps text-[9px] text-neutral-500 mt-1">{l}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
